import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import {
  Field,
  Input,
  ErrorGroup,
  Error,
  Button,
  FormStepCount,
  StepCountText,
  StepCountGraphics,
  Bar,
} from "../styles/form-step-styles";

const Step1 = ({
  errors,
  handleInputChange,
  handleSubmit,
  password,
  passwordConfirmation,
}) => {
  const isIe = detect().name === "ie";

  return (
    <Fragment>
      <FormStepCount className="animated fadeIn delay-2" isIe={isIe}>
        <StepCountText>Step 3/3 - Create Password</StepCountText>
        <StepCountGraphics isIe={isIe}>
          <Bar completed />
          <Bar completed />
          <Bar completed />
        </StepCountGraphics>
      </FormStepCount>
      <Field className="animated fadeInLeft delay-3">
        <Input
          type="password"
          name="password"
          value={password}
          spellCheck={false}
          placeholder="Please create your password"
          data-test-id="employer_registration_password"
          onChange={(e) => handleInputChange(e)}
        />
      </Field>
      <Field className="animated fadeInLeft delay-4">
        <Input
          type="password"
          name="passwordConfirmation"
          value={passwordConfirmation}
          spellCheck={false}
          placeholder="Please re-enter your password"
          data-test-id="employer_registration_password_confirmation"
          onChange={(e) => handleInputChange(e)}
        />
        {password !== passwordConfirmation && passwordConfirmation !== "" && (
          <Error doNotMatch>Passwords do not match.</Error>
        )}
        <ErrorGroup isIe={isIe}>
          {errors.password &&
            errors.password.map((error) => (
              <Error key={error}>{error && `Password ${error}.`}</Error>
            ))}
        </ErrorGroup>
      </Field>
      <Field className="animated fadeInUp delay-4">
        <Button
          data-test-id="employer_registration_next_button"
          onClick={(e) => handleSubmit(e)}
        >
          Next
        </Button>
      </Field>
    </Fragment>
  );
};

Step1.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    password: PropTypes.arrayOf(PropTypes.string),
    password_confirmation: PropTypes.arrayOf(PropTypes.string),
  }),
  password: PropTypes.string.isRequired,
  passwordConfirmation: PropTypes.string.isRequired,
};

Step1.defaultProps = {
  errors: PropTypes.isNull,
};

export default Step1;
